var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.erpCamposIntegracao && this.currentComponent && _vm.hasFields)?_c(_vm.currentComponent,{ref:"camposIntegracao",tag:"component",attrs:{"form-data":_vm.formData,"dense":_vm.dense}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }